
    import './styles.scoped.css';
    export default {
  "dialog": "awsui_dialog_1d2i7_7cfih_105",
  "modal-slide-up": "awsui_modal-slide-up_1d2i7_7cfih_1",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1d2i7_7cfih_1",
  "refresh": "awsui_refresh_1d2i7_7cfih_128",
  "awsui-motion-scale-popup": "awsui_awsui-motion-scale-popup_1d2i7_7cfih_1",
  "root": "awsui_root_1d2i7_7cfih_161",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_1d2i7_7cfih_1",
  "hidden": "awsui_hidden_1d2i7_7cfih_245",
  "focus-lock": "awsui_focus-lock_1d2i7_7cfih_249",
  "small": "awsui_small_1d2i7_7cfih_269",
  "medium": "awsui_medium_1d2i7_7cfih_272",
  "large": "awsui_large_1d2i7_7cfih_275",
  "max": "awsui_max_1d2i7_7cfih_278",
  "breakpoint-xs": "awsui_breakpoint-xs_1d2i7_7cfih_278",
  "container": "awsui_container_1d2i7_7cfih_284",
  "content": "awsui_content_1d2i7_7cfih_328",
  "no-paddings": "awsui_no-paddings_1d2i7_7cfih_333",
  "header": "awsui_header_1d2i7_7cfih_338",
  "header--text": "awsui_header--text_1d2i7_7cfih_350",
  "footer": "awsui_footer_1d2i7_7cfih_354",
  "footer--stuck": "awsui_footer--stuck_1d2i7_7cfih_363",
  "dismiss-control": "awsui_dismiss-control_1d2i7_7cfih_375",
  "modal-open": "awsui_modal-open_1d2i7_7cfih_379"
};
  